import React, { useMemo, useContext } from "react";
import PropTypes from "prop-types";
import {  Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DisplayIcon } from "./DisplayIcon";
import { MessageContent, MessagesWrapper } from "./MessagesStyles";
import { IconButton } from "@totalsoft/rocket-ui";
import { Replay } from "@mui/icons-material";
import { MessageCodes } from "./constants";
import { RightsContext } from "providers/RightsContext";
import * as rightsCodes from "constants/rightsCodes";
import { hasAuthorization } from "utils/functions";

const MessageComponent = ({
  messages,
  messageActiveTab,
  index,
  messageType,
  synchronizationInProgress,
  onRetrySynchronization
}) => {
  const { t } = useTranslation();
  const rights = useContext(RightsContext);
  const hasResyncPermission = hasAuthorization(rightsCodes.MASTER_PARTNER_SYNCHRONIZATION_HISTORY, rights);

  const disabledResync = !hasResyncPermission || synchronizationInProgress;

  const contentColor = useMemo(() => {
    switch (messageType) {
      case "Warning":
        return "warning";
      case "Error":
        return "error";
      case "Info":
      default:
        return "primary";
    }
  }, [messageType]);

  const sx = useMemo(() => ({ height: "20px", width: "20px", opacity: disabledResync ? 0.7 : 1 }), [disabledResync]);

  return (
    <MessagesWrapper active={Boolean(messageActiveTab)}>
      {messageActiveTab === index &&
        messages
          .filter(x => x.messageType === messageType)
          .map((item, index) => {
            return (
              <Box key={index} display="flex" justifyContent="space-between" alignItems="center">
                <MessageContent color={contentColor}>
                  <Box display="flex" gap={0.5}>
                    <DisplayIcon messageType={messageType} />
                    <span> {t(`PartnerMessages.${item.messageCode}`, item.data)}</span>
                  </Box>
                </MessageContent>
                {item.messageCode === MessageCodes.PartnerSynchronization && (
                  <IconButton
                    color="warning"
                    size="tiny"
                    onClick={onRetrySynchronization}
                    tooltip={t("Tooltips.Resync")}
                    disabled={disabledResync}
                  >
                    <Replay sx={sx} />
                  </IconButton>
                )}
              </Box>
            );
          })}
    </MessagesWrapper>
  );
};

MessageComponent.propTypes = {
  messages: PropTypes.array,
  messageActiveTab: PropTypes.any.isRequired,
  index: PropTypes.any.isRequired,
  children: PropTypes.node,
  messageType: PropTypes.string.isRequired,
  synchronizationInProgress: PropTypes.bool,
  onRetrySynchronization: PropTypes.func
};

export default MessageComponent;
